import React, { Component } from 'react';
import classNames from 'classnames';

class SubpageWrapperMultisection extends Component {

  render() {
    const { cssClassesList, isTemplate, children } = this.props;

    return(
      <div
        className={classNames('subpage-is-multisection', {
          'page-is-template': isTemplate
        }, cssClassesList)}
      >
        { children }
      </div>
    );
  }
}

export default SubpageWrapperMultisection;
